import React, { type ReactNode, useEffect, useState } from 'react';

// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy
import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context';
import { CoordinationClient } from '@atlassian/jira-engagement';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id';

const STARGATE_URL = '/gateway/api';

type Props = {
	messageId: string;
	fallback: ReactNode;
	children: ReactNode;
};

export const CoordinationClientWithFallback = ({ messageId, fallback, children }: Props) => {
	const { cloudId } = getTenantContext_DEPRECATED_DO_NOT_USE();
	const { data: orgId } = useOrgId();
	const [coordinationClient] = useState(
		new CoordinationClient(cloudId, STARGATE_URL, false, orgId),
	);
	const [didMessageStart, setDidMessageStart] = useState<boolean | undefined>(undefined);

	useEffect(() => {
		coordinationClient.start(messageId).then(setDidMessageStart);
	}, [coordinationClient, messageId]);

	switch (didMessageStart) {
		case true:
			return <>{children}</>;
		case false:
			return <>{fallback}</>;
		default:
			return null;
	}
};
